import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7uhhtfna: FaireBrandEntity = {
  token: "b_7uhhtfna",
  type: "brand",
  name: "ShoreBags",
  avatarUrl: "https://cdn.faire.com/fastly/4d52876ff03c4a5e47faa52c9c1e746c4e9083efe55778656896c11f14850d20.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/cbb562c36fae1230d5f87cd19937f91fb0a7a0bf44d7d4205d3b05f30996719e.png",
  logoUrl: "https://cdn.faire.com/fastly/4d52876ff03c4a5e47faa52c9c1e746c4e9083efe55778656896c11f14850d20.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/cbb562c36fae1230d5f87cd19937f91fb0a7a0bf44d7d4205d3b05f30996719e.png",
  location: "Chesterton, IN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 418,
  isTopShop: true,
  isInsider: true,
  description: "Made from sustainable raw materials in our family factory, ShoreBags's mission is to help reduce the amount of single-use plastic in the environment and empower local communities. We believe in ethical and fair manufacturing practices, transparent supply chains and creating bags that reflect the best in functionality and eco-fashion.\n\nGot a design idea?  Owning our own factory gives us unlimited possibilities to customize and rework our designs and offer private label services to our clients, while having complete control of supply chain and pricing.  We love collaborations and would welcome your ideas on working together. Contact us anytime at [redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:15:43.470Z",
    importedBy: "entity-db-cli"
  }
};
